import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/components/Button.module.css'; // Adjusted relative import

const Button = ({ onClick, onMouseDown, children, variant = 'primary', disabled = false, className, style, noHover = false, type = 'submit', title, ariaLabel }) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]} ${noHover ? styles.noHover : ''} ${className || ''}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      disabled={disabled}
      style={style}
      type={type}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'approve', 'cancel']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  noHover: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Button;